import { IMPACT_ICONS } from "./impactIcons";

export const COLLECTION_SCHEMAS = {
  career_entries: [
    { name: "title", type: "text", label: "Title" },
    { name: "org", type: "text", label: "Organization" },
    { name: "location", type: "text", label: "Location" },
    { name: "start_date", type: "text", label: "Start Date (e.g. 2024-01)" },
    { name: "end_date", type: "text", label: "End Date (blank if current)" },
    { name: "is_current", type: "boolean", label: "Current Role" },
    { name: "description", type: "textarea", label: "Description" },
    { name: "achievements", type: "array_string", label: "Achievements" },
    { name: "skills", type: "array_string", label: "Skills" },
    { name: "logo_url", type: "image", label: "Org Logo" },
    { name: "is_visible", type: "boolean", label: "Visible" },
  ],
  testimonials: [
    { name: "name", type: "text", label: "Name" },
    { name: "title", type: "text", label: "Title" },
    { name: "org", type: "text", label: "Organization" },
    { name: "relationship", type: "text", label: "Relationship" },
    { name: "full_quote", type: "textarea", label: "Full Quote" },
    { name: "short_quote", type: "text", label: "Short Quote" },
    { name: "portrait_url", type: "image", label: "Portrait" },
    { name: "portrait_alt", type: "text", label: "Portrait Alt Text" },
    { name: "linkedin_url", type: "text", label: "LinkedIn / Source URL" },
    { name: "org_logo_url", type: "image", label: "Org Logo" },
    { name: "verified", type: "boolean", label: "Verified (required to show publicly)" },
    { name: "status", type: "select", label: "Status", options: ["draft", "published", "archived"] },
  ],
  projects: [
    { name: "title", type: "text", label: "Title" },
    { name: "slug", type: "text", label: "Slug" },
    { name: "category", type: "text", label: "Category" },
    { name: "summary", type: "textarea", label: "Summary" },
    { name: "problem", type: "textarea", label: "Problem" },
    { name: "solution", type: "textarea", label: "Solution / Approach" },
    { name: "role", type: "text", label: "Role" },
    { name: "technologies", type: "array_string", label: "Technologies" },
    { name: "features", type: "array_string", label: "Features" },
    { name: "outcomes", type: "array_string", label: "Outcomes" },
    { name: "status", type: "select", label: "Project Status", options: ["Live", "In Development", "Concept", "Archived", "Private", "Case Study Available"] },
    { name: "thumbnail_url", type: "image", label: "Thumbnail" },
    { name: "screenshots", type: "array_string", label: "Screenshot URLs" },
    { name: "video_url", type: "text", label: "Video URL" },
    { name: "live_url", type: "text", label: "Live URL" },
    { name: "case_study_url", type: "text", label: "Case Study URL" },
    { name: "repo_url", type: "text", label: "Repository URL" },
    { name: "featured", type: "boolean", label: "Featured" },
    { name: "available_for_inquiry", type: "boolean", label: "Available For Inquiry" },
    { name: "is_published", type: "boolean", label: "Published (visible on site)" },
  ],
  services: [
    { name: "title", type: "text", label: "Title" },
    { name: "description", type: "textarea", label: "Description" },
    { name: "image_url", type: "image", label: "Graphic (optional)" },
    { name: "starting_price", type: "text", label: "Starting Price (shown as \"From …\"; e.g. $150 or $3,000/mo; leave blank to hide)" },
    { name: "capabilities", type: "array_string", label: "Capabilities" },
    { name: "cta_label", type: "text", label: "CTA Label" },
    { name: "cta_href", type: "text", label: "CTA Link (optional https://… URL; otherwise the button opens scheduling)" },
    { name: "is_published", type: "boolean", label: "Published (visible on site)" },
  ],
  products: [
    { name: "name", type: "text", label: "Name" },
    { name: "kind", type: "text", label: "Type label (e.g. Digital kit, Service · 30 min, Project)" },
    { name: "price", type: "text", label: "Price (shown as typed, e.g. $18 or $750 deposit)" },
    { name: "summary", type: "textarea", label: "Summary (on the card)" },
    { name: "details", type: "array_string", label: "Details (shown under Read more)" },
    { name: "href", type: "text", label: "Checkout link (https://… Gumroad or Stripe)" },
    { name: "cta", type: "text", label: "Button text (e.g. Buy on Gumroad, Book)" },
    { name: "is_published", type: "boolean", label: "Published (visible on site)" },
  ],
  thoughts: [
    { name: "title", type: "text", label: "Title" },
    { name: "slug", type: "text", label: "Slug" },
    { name: "excerpt", type: "textarea", label: "Excerpt" },
    { name: "body", type: "textarea", label: "Body (use blank lines between paragraphs)" },
    { name: "category", type: "text", label: "Category" },
    { name: "featured_image", type: "image", label: "Featured Image" },
    { name: "video_url", type: "text", label: "Video URL (YouTube / Vimeo / .mp4) — shown instead of the image when expanded" },
    { name: "reading_time", type: "text", label: "Reading Time (e.g. 5 min read)" },
    { name: "external_url", type: "text", label: "External URL (optional)" },
    { name: "featured", type: "boolean", label: "Featured" },
    { name: "is_published", type: "boolean", label: "Published (visible on site)" },
  ],
  impact_items: [
    { name: "title", type: "text", label: "Title" },
    { name: "org", type: "text", label: "Source / Medium (e.g. USA Today)" },
    { name: "date", type: "text", label: "Date" },
    { name: "category", type: "select", label: "Category", options: [] }, // AdminImpact fills from the live category list
    { name: "image_url", type: "image", label: "Image" },
    { name: "video_url", type: "text", label: "Video URL (YouTube/Vimeo/MP4 — optional)" },
    { name: "description", type: "textarea", label: "Short Description" },
    { name: "external_link", type: "text", label: "Link to Full Content" },
    { name: "role", type: "text", label: "Role" },
    { name: "featured", type: "boolean", label: "Featured" },
    { name: "is_published", type: "boolean", label: "Published (visible on site)" },
  ],
  impact_categories: [
    { name: "label", type: "text", label: "Label (tile title)" },
    { name: "key", type: "text", label: "Key (saved on each item; renaming updates all its items)" },
    { name: "subtitle", type: "text", label: "Subtitle" },
    { name: "icon", type: "select", label: "Icon", options: Object.keys(IMPACT_ICONS) },
    { name: "is_published", type: "boolean", label: "Visible on site" },
  ],
};
